<script>
  /**
   * Created by uiuifree on 2017/04/06.
   */
  import Api from './Api.vue'

  //  import axios from 'axios'
  //  import VueCookie from 'vue-cookie'
  export default {
    async: {
      prefectures: async function () {
        var prefectures = sessionStorage.getItem('prefectures') || false
        if (prefectures) {
          prefectures = JSON.parse(prefectures)
        } else {
          const res = await Api.prefecture.list({})
          prefectures = res.data.prefectures || false
          if (prefectures) {
            sessionStorage.setItem('prefectures', JSON.stringify(prefectures))
          }
        }
        return prefectures
      },
      cities: async function () {
        var cities = sessionStorage.getItem('cities') || false
        if (cities) {
          cities = JSON.parse(cities)
        } else {
          const res = await Api.city.search({})
          cities = res.data.cities || false
          console.log(res.data.cities)
          if (cities) {
            sessionStorage.setItem('cities', JSON.stringify(cities))
          }
        }
        return cities
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WebStorage.vue?d0c0ba72